import {useLoaderData} from 'react-router-dom';
import React, {useState, useEffect} from "react";
import { useUser } from "../components/UserContext";
import { createUser, getUser, initialiseBaseSkins } from '../Users'
import PersonAddIcon from '@mui/icons-material/PersonAdd';

export async function loader({params}) {
    const userId = params.userId;
    const user = await getUser(userId);
    if (Number(userId) !== 1) {
        throw new Response("", {
            status: 404,
            statusText: "Not Found",
        });
    }
    return {user};
}

export default function CreateUser() {
    const {user} = useLoaderData();
    const {currentUser} = useUser();
    const [target, setTarget] = useState({location: [], method: "edit"});
    const [input, setInput] = useState({name: "", username: "", email: "", password: ""});

    useEffect(() => {
        initialiseBaseSkins(currentUser.id);
        document.title = "Create User";
    }, [currentUser.id]);

    function handleChange(event) {
        const { name, value, type, checked } = event.target;
        setInput(prevInput => ({
            ...prevInput,
            [name]: type === "checkbox"? (checked ? 1 : 0) : value
        }));
    }

    function edit(newItem) { //replace function
        createUser(newItem);//replace
        window.location.reload();
    }

    function submit() {
        if(input.username.length === 0) return;
        if (target.method === "edit") {
            const newItem = {
                name: input.name,
                username: input.username,
                email: input.email,
                password: input.password,
            }
              edit(newItem);
              setTarget((prev) => ({...prev, method : null}));
          }
    }

    if (user.id === currentUser.id) return(
        <div>
            <div className="page-head">
                <div className="page-title">
                    <div className="creator-pfp"><PersonAddIcon className="creator-default-pfp"/></div>
                    <h2 className="title-text">Create User</h2>
                    <h3>Create new users</h3>
                </div>
            </div>
            <div>
                <div id="folder-create-container">
                    <div id="skin-create">
                        <div>
                            <div>
                                <label> Name:  
                                    <input name="name" onChange={handleChange} value={input.name} placeholder="Name" type="text"/>
                                </label>
                                <label> Username:
                                    <input name="username" onChange={handleChange} value={input.username} placeholder="Username" type="text"/>
                                </label>
                                <label> Email: 
                                    <input name="email" onChange={handleChange} value={input.email} placeholder="Email" type="text"/>
                                </label>
                                <label> Password
                                    <input name="password" onChange={handleChange} value={input.password} placeholder="Password" type="text"/>
                                </label>
                            </div>
                        </div>

                        <div id="skin-submit-container">
                            <div>
                                <button id="folder-submit-button" onClick={submit}>Submit</button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}